// extracted by mini-css-extract-plugin
module.exports = {"hitCounterText":"AtHitCounter_hitCounterText__1eTvl"};